import React from "react";
import {
  CubeTransparentIcon,
  HeartIcon,
  ArrowDownIcon,
} from "@heroicons/react/24/solid";
import Section from "./Section";
import SectionHeader from "./SectionHeader";

function HeroSection2(props) {


  return (
    <Section
      size={props.size}
      bgColor={props.bgColor}
      bgImage={props.bgImage}
      bgImageOpacity={props.bgImageOpacity}
      textColor={props.textColor}
    >
<div className="space-y-16 container px-4 sm:px-6 lg:px-16 max-w-4xl mx-auto">
  <div>
    <SectionHeader
      title={props.title}
      subtitle={props.subtitle}
      strapline={props.strapline}
      className="lg:w-1/2"
    />
  </div>


  <div className="text-gray-700 space-y-6">
    <p className="leading-relaxed text-xl"> 
     Welcome to Intuuch! We’re excited to announce that our beta app is currently being released in select locations. 
    </p>


    <p className="leading-relaxed text-xl">
     This is your chance to get a first look at what’s coming and be part of shaping the future of Intuuch. While you explore its features, know that even more is on the way!
    </p>

    <p className="leading-relaxed text-xl">
      If you would like Intuuch to come to your city or want to collaborate with us, feel free to connect with us via email - hello@jyni.app :)
    </p>


    <p className="leading-relaxed text-xl">
      Stay tuned and get ready, something big is coming.
    </p>
 
    <p className="leading-relaxed text-xl">
      Best,<br />
      Intuuch Team
    </p>
  </div>


 


   {/* Adding the three paragraphs here 
   
       I love reading physical books, including foreign language books that are often only available physically through online stores, because reading in a language is fundamental to learning the language, its culture, and its values. 

   <div className="text-gray-700 space-y-6">
    <p className="leading-relaxed text-xl">
    I love reading books and books in foreign languages. Foreign language books are a special case because it’s usually necessary for individuals to buy the book they want to read since they’re not as readily available in libraries or bookstores. Over the years,  I’ve developed a deep connection with physical books and generally prefer them over other formats.

    </p>
    <p className="leading-relaxed text-xl">

    I created The Book Road because I realized I would love to share the books I loved reading and find recycled books more easily. I imagine that others would also like giving their books a new life and bringing joy to people who they know would enjoy them. If this sounds interesting to you or you have something else to share, feel free to reach out! I’m always excited to meet new people and hear their perspectives.

    </p>
 

  </div>

  <div className="grid grid-cols-1 md:grid-cols-3 gap-16">
    {items.map((item, index) => (
      <div key={index}>
        <h3 className="flex items-center space-x-2 text-lg font-bold uppercase tracking-wide mb-2">
          <item.icon
            className={
              "inline-block w-5 h-5" +
              (item.iconColor ? ` ${item.iconColor}` : "")
            }
          />
          <span>{item.title}</span>
        </h3>
        <p className="leading-relaxed text-gray-600">
          {item.description}
        </p>
      </div>
    ))}
  </div>
*/}
</div>

    </Section>
  );
}

export default HeroSection2;
